// @ts-nocheck
// comments: Newsletter with native HTML5 email validation + force lowercase input
import React, { useState } from "react";
import call from "../../assets/footer/call.svg";
import mail from "../../assets/footer/mail-01.svg";
import instagram from "../../assets/footer/instagram.svg";
import linkedin from "../../assets/footer/linkedin-02.svg";
import twitter from "../../assets/footer/new-twitter.svg";
import snap from "../../assets/footer/snapchat.svg";
import whatsapp from "../../assets/footer/whatsapp.svg";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import contentApi from "../../api/contentApi";

// comments: helper to force lowercase and strip invalid chars
const sanitizeEmail = (val) =>
  val
    .toLowerCase()
    .replace(/\s+/g, "") // remove spaces
    .replace(/[^a-z0-9._%+-@-]/g, ""); // allow only email-safe chars

const Newsletter = (SettingData) => {
  const { t } = useTranslation("Footer");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // comments: keep same signature you requested
  const handleSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true);
      await contentApi.NewsLetterMessage(values); // { email }
      toast.success(t("Message sent successfully!"), { autoClose: 5000 });
      resetForm(); // reset email input
    } catch (error) {
      toast.error(
        t("An error occurred while sending. Please try again."),
        { autoClose: 5000 }
      );
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // comments: social icons data
  const socialIcons = [
    { src: snap, alt: "Snapchat" },
    { src: twitter, alt: "Twitter" },
    { src: whatsapp, alt: "WhatsApp" },
    { src: linkedin, alt: "LinkedIn" },
    { src: instagram, alt: "Instagram" },
  ];

  return (
    <div className="flex flex-col gap-6 sm:gap-12 w-full max-w-[454px] px-4 sm:px-0">
      {/* Newsletter Section */}
      <div className="flex flex-col gap-6 sm:gap-8">
        <div className="flex flex-col gap-2 sm:gap-3">
          <span className="text-[20px] leading-[33.6px] sm:text-[24px] font-semibold text-[#1d1d1d]">
            {t("footer.newsletter_title")}
          </span>
          <span className="text-[12px] sm:text-[14px] text-[#667680] leading-[21px]">
            {t("footer.newsletter_description")}
          </span>
        </div>

        {/* form for validation */}
        <form
          onSubmit={(e) => {
            if (!e.currentTarget.checkValidity()) {
              e.preventDefault();
              e.currentTarget.reportValidity();
              return;
            }
            e.preventDefault();
            handleSubmit(
              { email: email.trim().toLowerCase() },
              { resetForm: () => setEmail("") }
            );
          }}
          noValidate={false}
          className="flex gap-4 items-start md:block"
        >
          {/* Email Input */}
          <div className="relative flex-1">
            <div className="flex items-center justify-end bg-[#fff] rounded-[12px] border h-[45px] border-[#f1f3f9] p-5">
              <img src={mail} alt="Email Icon" className="w-[16px] h-[16px]" />
            </div>

            <input
              name="email"
              value={email}
              onChange={(e) => setEmail(sanitizeEmail(e.target.value))}
              onPaste={(e) => {
                e.preventDefault();
                const text = (e.clipboardData || window.clipboardData).getData("text");
                setEmail(sanitizeEmail(text));
              }}
              className="absolute inset-0 w-full h-full font-semibold leading-[21px] bg-transparent border-none outline-none text-[12px] sm:text-[14px] placeholder-[#667680] p-5 normal-case lowercase"
              style={{ textTransform: "lowercase" }}
              placeholder={t("footer.email_placeholder")}
              type="email"
              required
              inputMode="email"
              autoComplete="email"
              dir="ltr"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}"
              aria-invalid={email ? "false" : "true"}
            />
          </div>

          {/* Subscribe Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-[80px] md:w-full md:mt-3 sm:w-[99px] h-[40px] sm:h-[45px] flex items-center justify-center bg-[#0d6b70] rounded-[12px] text-white shadow-md"
          >
            {t("footer.subscribe_now")}
          </button>
        </form>
      </div>

      {/* Social Media Icons */}
      <div className="flex justify-start gap-4 sm:gap-4">
        <a
          href={SettingData?.SettingData?.data[0]?.setting?.social?.snapchat}
          className="w-[20px] h-[20px]"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={socialIcons[0].src} alt={socialIcons[0].alt} className="w-full h-full object-cover" />
        </a>

        <a
          href={SettingData?.SettingData?.data[0]?.setting?.social?.twetter}
          className="w-[20px] h-[20px]"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={socialIcons[1].src} alt={socialIcons[1].alt} className="w-full h-full object-cover" />
        </a>

        <a
          href={SettingData?.SettingData?.data[0]?.setting?.social?.whatsapp}
          className="w-[20px] h-[20px]"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={socialIcons[2].src} alt={socialIcons[2].alt} className="w-full h-full object-cover" />
        </a>

        <a
          href={SettingData?.SettingData?.data[0]?.setting?.social?.linked_in}
          className="w-[20px] h-[20px]"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={socialIcons[3].src} alt={socialIcons[3].alt} className="w-full h-full object-cover" />
        </a>

        <a
          href={SettingData?.SettingData?.data[0]?.setting?.social?.instgram}
          className="w-[20px] h-[20px]"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={socialIcons[4].src} alt={socialIcons[4].alt} className="w-full h-full object-cover" />
        </a>
      </div>

      {/* Toast notifications */}
      {/* <ToastContainer position="top-right" /> */}
    </div>
  );
};

export default Newsletter;
